import React, { useState, useEffect, useCallback } from 'react';
import '..//FinalizarVenda.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, message, Select } from 'antd';
import PaymentScreen from '../Pagamento/PaymentScreen';
import Pagamento from '../Pagamento/Pagamento';
import axios from 'axios';
import Parametros from '..//Parametros';
import AcresDesc from '../AcresDec/AcrescimoDescontoTotal';
import AcrescimoDescontoTotal from '../AcresDec/AcrescimoDescontoTotal';
import IdentificarConsumidor from '../FinalizarVenda/IdentificarConsumidor';
import { useConfigQuery } from '../../../../queries/useConfig';
import { api } from '../../../../config/api';
import { formatarQuantidade, formatarValor } from '../../../../utils/formatters';
import { jsPDF } from 'jspdf';

const FinalizarOrcamento = ({
  consumidorIdentificado,
  setConsumidorIdentificado,
  closeModal,
  nomeCupom,
  documentoCupom,
  setNomeCupom,
  setDocumentoCupom,
  consumidor,
  setConsumidor,
  precoTotal,
  pagamentoConcluido,
  setPagamentoConcluido,
  pagamentos,
  setPagamentos,
  produtos,
  setProdutos,
  subTotal,
  CalcularTotais,
  acresDescFrete,
  setAcresDescFrete,
  totalDescontos,
  totalAcrescimos,
  acresDescFreteConcluido,
  setAcresDescFreteConcluido,
  setPagItem,
  pagItem,
  formasDePagamento,
  idVendedorOrcamento,
  idOrcamento,
  setVendaPuxada,
  focarCodigoDeBarras,
  travarAcrescimoDescFrete,
  tipoTela,
  sessaoCaixa
}) => {
  const { data: config, error } = useConfigQuery();
  const [isModalVisibleConsumidor, setIsModalVisibleConsumidor] = useState(false);
  const [isModalVisibleParametros, setIsModalVisibleParametros] = useState(false);
  const [isModalVisiblePagamento, setIsModalVisiblePagamento] = useState(false);
  const [isModalVisibleAcresDesc, setIsModalVisibleAcresDesc] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loja, setLoja] = useState('');
  // Apenas utiliza o HTML customizado quando ha uma estrutura HTML
  // reconhecivel e conteudo visivel para o cupom.
  const validarHtmlPersonalizado = (valor) => {
    if (typeof valor !== 'string' || !valor.trim()) return false;

    const html = valor.trim();
    if (!/<[a-z][\w:-]*(?:\s[^<>]*)?\s*\/?>/i.test(html)) return false;

    try {
      const documento = new DOMParser().parseFromString(html, 'text/html');
      if (documento.querySelector('parsererror')) return false;
      // Evita criar PDFs vazios com HTML contendo apenas estilos ou scripts.
      const copia = documento.body.cloneNode(true);
      copia.querySelectorAll('script, style, template, noscript').forEach((el) => el.remove());
      return Boolean(copia.textContent?.trim() || copia.querySelector('img, svg, canvas'));
    } catch (error) {
      return false;
    }
  };

  // Configuracoes opcionais de impressao salvas no restaurante.
  // Aceita objeto ou JSON string, caso o backend serialize o campo.
  const obterPersonalizacao = (tipo) => {
    const campo = tipo === 'pedido' ? 'pedidoCustomizado' : 'orcamentoCustomizado';
    const bruto = loja?.[campo] ?? config?.restaurante?.[campo];
    let personalizacao = bruto;

    if (typeof bruto === 'string') {
      try {
        personalizacao = JSON.parse(bruto);
      } catch (error) {
        personalizacao = null;
      }
    }

    const chavePrefixo = tipo === 'pedido'
      ? 'prefixoPedidoCustomizado'
      : 'prefixoOrcamentoCustomizado';
    const prefixoPadrao = tipo === 'pedido' ? 'C' : 'F';
    const prefixoInformado = String(personalizacao?.[chavePrefixo] ?? '').trim();
    // Evita caracteres invalidos no nome do arquivo.
    const prefixo = prefixoInformado.replace(/[^a-zA-Z0-9_-]/g, '') || prefixoPadrao;
    const html = typeof personalizacao?.html === 'string'
      ? personalizacao.html.trim()
      : '';

    return { prefixo, html: validarHtmlPersonalizado(html) ? html : '' };
  };

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [serieDefault, setSerieDefault] = useState('');
  const [indPag, setIndPag] = useState('0');
  const codigosProdutos = window.localStorage.getItem('codigosProdutos');
  const [emailNota, setEmailNota] = useState('');
  const [telefoneEnvio, setTelefoneEnvio] = useState('');
  const [totalPago, setTotalPago] = useState(0);
  const [parametros, setParametros] = useState({
    infCpl: ''
  });
  const operador = window.localStorage.getItem("operador");


  const [subTotalProdutos, setSubTotalProdutos] = useState(0);
  const [totalDescontosProdutos, setTotalDescontosProdutos] =
    useState(0);
  const [totalAcrescimosProdutos, setTotalAcrescimosProdutos] =
    useState(0);
  const [freteProdutos, setFreteProdutos] = useState(0);

  const [totalProdutos, setTotalProdutos] = useState(0);
  const [totalServicos, setTotalServicos] = useState(0);
  const [freteServicos, setFreteServicos] = useState(0);

  const [subTotalServicos, setSubTotalServicos] = useState(0);
  const [totalDescontosServicos, setTotalDescontosServicos] =
    useState(0);
  const [totalAcrescimosServicos, setTotalAcrescimosServicos] =
    useState(0);
  //Usuarios
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const habilitarSelecaoVendedor =
    config?.terminalComercial?.selecionarVendedorNaFinalizacao === true;

  const obterCodigoProdutoNota = (produto, config) => {
    const tipoCodigo =
      config?.terminalComercial?.codigoProdutoNota ?? 'ID';

    const idOriginal = String(produto.id);

    let codigoSelecionado;

    switch (tipoCodigo) {
      case 'EAN':
        codigoSelecionado = produto.ean;
        break;

      case 'SKU':
        codigoSelecionado = produto.sku;
        break;

      case 'CODIGO_INTERNO':
        codigoSelecionado = produto.codigo;
        break;

      case 'ID':
      default:
        return idOriginal;
    }

    const codigo = String(codigoSelecionado ?? '').trim();

    return codigo || idOriginal;
  };


  const buscarUsuarios = async () => {
    if (!config?.idLoja) return;

    try {
      setLoadingUsuarios(true);

      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      const response = await axios.get(
        `${api.techfood}/v1/restaurantes/${config.idLoja}/responsaveis`,
        options
      );

      const lista = response.data?._embedded?.usuarios || [];

      // opcional: mostra somente usuários ativos e não bloqueados
      const usuariosValidos = lista.filter(
        (usuario) =>
          usuario.ativo === true &&
          usuario.bloqueio === false
      );

      setUsuarios(usuariosValidos);

      // deixa o usuário logado selecionado automaticamente
      const usuarioLogado = usuariosValidos.find(
        (usuario) =>
          String(usuario.id) === String(idUser)
      );

      if (usuarioLogado) {
        setUsuarioSelecionado(usuarioLogado.id);
      }

    } catch (error) {
      console.error('Erro ao buscar usuários:', error);

      message.error(
        'Não foi possível carregar os usuários da loja.'
      );

      setUsuarios([]);
    } finally {
      setLoadingUsuarios(false);
    }
  };
  useEffect(() => {
    if (
      habilitarSelecaoVendedor &&
      config?.idLoja
    ) {
      buscarUsuarios();
    }
  }, [
    habilitarSelecaoVendedor,
    config?.idLoja,
  ]);

  useEffect(() => {
    console.log(produtos);
  }, [produtos])

  useEffect(() => {
    const converterNumero = (valor) => {
      if (
        valor === null ||
        valor === undefined ||
        valor === ''
      ) {
        return 0;
      }

      if (typeof valor === 'number') {
        return Number.isFinite(valor) ? valor : 0;
      }

      const valorTexto = String(valor)
        .trim()
        .replace(/\s/g, '');

      const valorNormalizado =
        valorTexto.includes(',') &&
          valorTexto.includes('.')
          ? valorTexto
            .replace(/\./g, '')
            .replace(',', '.')
          : valorTexto.includes(',')
            ? valorTexto.replace(',', '.')
            : valorTexto;

      const numero = Number(valorNormalizado);

      return Number.isFinite(numero) ? numero : 0;
    };

    const arredondar = (valor) =>
      Math.round(
        (Number(valor) + Number.EPSILON) * 100
      ) / 100;

    const totaisProdutos = {
      subtotal: 0,
      descontos: 0,
      acrescimos: 0,
      frete: 0,
      total: 0,
    };

    const totaisServicos = {
      subtotal: 0,
      descontos: 0,
      acrescimos: 0,
      frete: 0,
      total: 0,
    };

    const obterCodigoProdutoNota = (produto, config) => {
      const tipoCodigo =
        config?.terminalComercial?.codigoProdutoNota ?? 'ID';

      const idOriginal = String(produto.id);

      let codigoSelecionado;

      switch (tipoCodigo) {
        case 'EAN':
          codigoSelecionado = produto.ean;
          break;

        case 'SKU':
          codigoSelecionado = produto.sku;
          break;

        case 'CODIGO_INTERNO':
          codigoSelecionado = produto.codigo;
          break;

        case 'ID':
        default:
          return idOriginal;
      }

      const codigo = String(codigoSelecionado ?? '').trim();

      return codigo || idOriginal;
    };

    const listaProdutos = Array.isArray(produtos)
      ? produtos
      : [];

    listaProdutos.forEach((produto) => {
      const quantidade = converterNumero(
        produto?.quantidade
      );

      const preco = converterNumero(
        produto?.preco
      );

      const desconto = converterNumero(
        produto?.valorDesconto ??
        produto?.desconto
      );

      const acrescimo = converterNumero(
        produto?.valorAcrescimo ??
        produto?.acrescimo
      );

      const frete = converterNumero(
        produto?.frete
      );

      const subtotalItem = quantidade * preco;

      const totalItem =
        subtotalItem +
        acrescimo +
        frete -
        desconto;

      const tipoItem =
        produto?.ntipoItem ??
        produto?.nTipoItem ??
        produto?.tipoItem ??
        0;

      const ehServico =
        String(tipoItem) === '5';

      const acumulador = ehServico
        ? totaisServicos
        : totaisProdutos;

      acumulador.subtotal += subtotalItem;
      acumulador.descontos += desconto;
      acumulador.acrescimos += acrescimo;
      acumulador.frete += frete;
      acumulador.total += totalItem;
    });

    setSubTotalProdutos(
      arredondar(totaisProdutos.subtotal)
    );

    setTotalDescontosProdutos(
      arredondar(totaisProdutos.descontos)
    );

    setTotalAcrescimosProdutos(
      arredondar(totaisProdutos.acrescimos)
    );

    setFreteProdutos(
      arredondar(totaisProdutos.frete)
    );

    setTotalProdutos(
      arredondar(totaisProdutos.total)
    );

    setSubTotalServicos(
      arredondar(totaisServicos.subtotal)
    );

    setTotalDescontosServicos(
      arredondar(totaisServicos.descontos)
    );

    setTotalAcrescimosServicos(
      arredondar(totaisServicos.acrescimos)
    );

    setFreteServicos(
      arredondar(totaisServicos.frete)
    );

    setTotalServicos(
      arredondar(totaisServicos.total)
    );
  }, [produtos, acresDescFrete]);



  const toggleModalIdentificarConsumidor = () => {
    setIsModalVisibleConsumidor(!isModalVisibleConsumidor);
  };

  const toggleModalParametros = () => {
    setIsModalVisibleParametros(!isModalVisibleParametros);
  };

  const toggleModalPagamento = () => {
    setIsModalVisiblePagamento(!isModalVisiblePagamento);
  };

  const toggleModalAcresDesc = () => {
    setIsModalVisibleAcresDesc(!isModalVisibleAcresDesc);
  };
  function formatarTelefone(numero) {
    const apenasNumeros = numero.replace(/\D/g, '');

    if (apenasNumeros.length === 13) {
      // Ex: 55 11 91234-5678
      return `+${apenasNumeros.slice(0, 2)} (${apenasNumeros.slice(2, 4)}) ${apenasNumeros.slice(4, 9)}-${apenasNumeros.slice(9)}`;
    } else if (apenasNumeros.length === 11) {
      // Ex: 11 91234-5678
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7)}`;
    } else if (apenasNumeros.length === 10) {
      // Ex: 11 1234-5678
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 6)}-${apenasNumeros.slice(6)}`;
    } else {
      // Retorna o número cru se não casar
      return numero;
    }
  }

  const [
    acrescimoDescontosFreteConcluido,
    setAcrescimoDescontosFreteConcluido,
  ] = useState(false);

  const criarEvento = async (venda) => {
    let erroBol = false;
    console.log('dentro do criarEvento');

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken, // Certifique-se de definir `accessToken`
      },
    };

    try {
      const response = await axios.post(
        `${api.techspdv}/v1/pdveventos/venda`,
        venda,
        options
      );

      console.log('Requisição bem-sucedida');

      // Recuperar vendas não salvas do localStorage
      const vendasNaoSalvas = window.localStorage.getItem('vendasNaoSalvas');
      const vendasArray = vendasNaoSalvas ? JSON.parse(vendasNaoSalvas) : [];

      // Filtrar para excluir o item com a chave de acesso correspondente
      const novoArray = vendasArray.filter(
        (item) => item.InfoSistema.chaveDocFiscal !== venda.chaveDocFiscal
      );

      // Atualizar o localStorage com o array filtrado
      window.localStorage.setItem('vendasNaoSalvas', JSON.stringify(novoArray));
      console.log('Item removido com sucesso do array vendasNaoSalvas.');

      // Retornar a resposta da requisição
      return response;
    } catch (error) {
      erroBol = true;

      // Tratamento de erro
      if (error.response) {
        console.log('Status de erro:', error.response.status);
        console.log('Dados de erro:', error.response.data);

        const retry = window.confirm(
          'Falha ao gravar o histórico. Deseja tentar novamente?'
        );

        if (retry) {
          console.log('Tentar novamente');
          return await criarEvento(venda);
        } else {
          console.log('Usuário escolheu não tentar novamente.');
          // Realizar ações adicionais se o usuário escolher não tentar novamente
          setLoading(false);
          closeModal();
          setProdutos([]);
          setConsumidor(null);
          setNomeCupom('');
          setDocumentoCupom('');
          setConsumidorIdentificado(false);
          return null;
        }
      }

      console.error('Erro inesperado:', error);
      return null;
    }
  };

  function formatPhoneNumber(phoneNumber) {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');

    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/) || cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);

    if (match) {
      const intlCode = '+55 ';
      const part1 = match[1];
      const part2 = match[2];
      const part3 = match[3];

      return `(${part1}) ${part2}-${part3}`;
    }

    return null;
  }

  function trataXProd(str1, str2) {
    const maxLen = 119;

    // normaliza entradas e remove quebras de linha
    str1 = String(str1 || "").replace(/[\r\n]+/g, " ").trim();
    str2 = String(str2 || "").replace(/[\r\n]+/g, " ").trim();

    // se str2 não vier nada, retorna só str1 (cortado no limite)
    if (!str2) {
      return str1.slice(0, maxLen);
    }

    // monta a string concatenada com " - "
    let result = `${str1} - ${str2}`;

    // aplica limite de 120 caracteres
    if (result.length > maxLen) {
      result = result.slice(0, maxLen);
    }

    return result;
  }

  const formatarMoeda = (valor) => {
    return Number(valor || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };
  const CardNotaFiscal = ({
    icone,
    titulo,
    subtotal,
    descontos,
    acrescimos,
    frete,
    total,
    mostrarFrete = true,
  }) => (
    <div style={estiloCardFinanceiro}>
      <div style={estiloTituloCardFinanceiro}>
        <span>{icone}</span>
        <span>{titulo}</span>
      </div>

      <div style={estiloGridFinanceiro}>
        <div style={estiloItemFinanceiro}>
          <span style={estiloLabelResumo}>Subtotal</span>
          <strong style={estiloValorResumo}>
            {formatarMoeda(subtotal)}
          </strong>
        </div>

        <div style={estiloItemFinanceiro}>
          <span style={estiloLabelResumo}>Descontos</span>
          <strong style={estiloValorResumo}>
            {formatarMoeda(descontos)}
          </strong>
        </div>

        <div style={estiloItemFinanceiro}>
          <span style={estiloLabelResumo}>Acréscimos</span>
          <strong style={estiloValorResumo}>
            {formatarMoeda(acrescimos)}
          </strong>
        </div>

        {mostrarFrete && (
          <div style={estiloItemFinanceiro}>
            <span style={estiloLabelResumo}>Frete</span>
            <strong style={estiloValorResumo}>
              {formatarMoeda(frete)}
            </strong>
          </div>
        )}
      </div>

      <div style={estiloTotalFinanceiro}>
        <span style={estiloLabelTotalFinanceiro}>Total</span>

        <strong style={estiloValorTotalFinanceiro}>
          {formatarMoeda(total)}
        </strong>
      </div>
    </div>
  );
  function gerarCodigoComData() {
    const tz = 'America/Sao_Paulo';
    const now = new Date();

    const parts = new Intl.DateTimeFormat('pt-BR', {
      timeZone: tz,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    })
      .formatToParts(now)
      .reduce((acc, p) => ((acc[p.type] = p.value), acc), {});

    const yyyymmddhhmmss = `${parts.year}${parts.month}${parts.day}${parts.hour}${parts.minute}${parts.second}`;
    return `${yyyymmddhhmmss}`;
  }

  const buscarNomeVendedor = async (idVendedor) => {
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
    const nomeVendedor = await axios.get(`${api.techspdv}/v1/usuarios/${idVendedor}`, options);
    return nomeVendedor.data.nome || '';
  }

  const possuiPagamento = pagItem?.length > 0;

  const obterResumoPagamentos = () => {
    if (!pagItem?.length) {
      return 'Nenhum pagamento';
    }

    return [
      ...new Set(
        pagItem.map((item) => item.xPag)
      ),
    ].join(' • ');
  };

  const baixarCupomPdf = async (htmlContent, nomeArquivo) => {
    const htmlComQuebras = String(htmlContent || '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/div>/gi, '\n');

    const parser = new DOMParser();
    const documento = parser.parseFromString(
      htmlComQuebras,
      'text/html'
    );

    const linhasOriginais = (documento.body.textContent || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\r/g, '')
      .split('\n')
      .map((linha) => linha.trim())
      .filter((linha, index, arr) => {
        if (linha) return true;
        return index > 0 && arr[index - 1];
      });

    const larguraPapel = 80;
    const margem = 8;
    const larguraUtil = larguraPapel - (margem * 2);
    const centro = larguraPapel / 2;

    const pdfMedidor = new jsPDF({
      unit: 'mm',
      format: [larguraPapel, 200],
      orientation: 'portrait',
    });

    const medirLinhas = (texto, largura, tamanho = 9, fonte = 'courier', estilo = 'normal') => {
      pdfMedidor.setFont(fonte, estilo);
      pdfMedidor.setFontSize(tamanho);
      return pdfMedidor.splitTextToSize(String(texto || ''), largura);
    };

    const elementos = [];

    const adicionarEspaco = (altura = 2) => {
      elementos.push({ tipo: 'espaco', altura });
    };

    const adicionarSeparador = (duplo = false) => {
      elementos.push({ tipo: 'separador', duplo });
    };

    const adicionarTexto = ({
      texto,
      tamanho = 9,
      estilo = 'normal',
      alinhamento = 'left',
      largura = larguraUtil,
      margemEsquerda = margem,
      alturaLinha = 4,
    }) => {
      elementos.push({
        tipo: 'texto',
        texto: String(texto || ''),
        tamanho,
        estilo,
        alinhamento,
        largura,
        margemEsquerda,
        alturaLinha,
      });
    };

    const formatarCnpj = (valor) => {
      const numeros = String(valor || '').replace(/\D/g, '');

      if (numeros.length !== 14) {
        return valor;
      }

      return numeros.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
    };

    const indicePedido = linhasOriginais.findIndex((linha) =>
      /^(PEDIDO|ORÇAMENTO|ORCAMENTO)\b/i.test(linha)
    );

    const indicePagamento = linhasOriginais.findIndex((linha) =>
      /^FORMAS DE PAGAMENTO$/i.test(linha)
    );

    const indiceVendedor = linhasOriginais.findIndex((linha) =>
      /^Vendedor:/i.test(linha)
    );

    linhasOriginais.forEach((linha, index) => {
      if (!linha) {
        adicionarEspaco(1.5);
        return;
      }

      // Cabeçalho da empresa
      if (index === 0) {
        adicionarTexto({
          texto: linha,
          tamanho: 11,
          estilo: 'bold',
          alinhamento: 'center',
          alturaLinha: 4.5,
        });
        return;
      }

      if (/^CNPJ\s*-/i.test(linha)) {
        const valor = linha.replace(/^CNPJ\s*-\s*/i, '');
        adicionarTexto({
          texto: `CNPJ ${formatarCnpj(valor)}`,
          tamanho: 8.5,
          alinhamento: 'center',
          alturaLinha: 3.8,
        });
        return;
      }

      if (/^IE\s*-/i.test(linha)) {
        const valor = linha.replace(/^IE\s*-\s*/i, '');
        adicionarTexto({
          texto: `IE ${valor}`,
          tamanho: 8.5,
          alinhamento: 'center',
          alturaLinha: 3.8,
        });
        return;
      }

      // Endereço / data antes do bloco do pedido
      if (
        indicePedido > -1 &&
        index < indicePedido &&
        !/^Cliente:/i.test(linha) &&
        !/^\d{2}\/\d{2}\/\d{4}/.test(linha)
      ) {
        adicionarTexto({
          texto: linha,
          tamanho: 8.5,
          alinhamento: 'center',
          alturaLinha: 3.8,
        });
        return;
      }

      if (/^\d{2}\/\d{2}\/\d{4}/.test(linha)) {
        adicionarEspaco(1);
        adicionarTexto({
          texto: linha,
          tamanho: 8.5,
          alinhamento: 'center',
          alturaLinha: 3.8,
        });
        adicionarEspaco(1);
        return;
      }

      if (/^Cliente:/i.test(linha)) {
        const cliente = linha.replace(/^Cliente:\s*/i, '').trim();

        if (cliente) {
          adicionarTexto({
            texto: `Cliente: ${cliente}`,
            tamanho: 8.5,
            estilo: 'bold',
          });
          adicionarEspaco(1);
        }
        return;
      }

      // Pedido / orçamento
      if (/^(PEDIDO|ORÇAMENTO|ORCAMENTO)\b/i.test(linha)) {
        adicionarEspaco(1.5);
        adicionarSeparador();
        adicionarTexto({
          texto: linha,
          tamanho: 11,
          estilo: 'bold',
          alinhamento: 'center',
          alturaLinha: 4.8,
        });
        return;
      }

      if (/^CUPOM SEM VALOR FISCAL$/i.test(linha)) {
        adicionarTexto({
          texto: linha,
          tamanho: 8.5,
          estilo: 'bold',
          alinhamento: 'center',
          alturaLinha: 4,
        });
        adicionarSeparador();
        adicionarEspaco(1.5);
        return;
      }

      // Pagamento
      if (/^FORMAS DE PAGAMENTO$/i.test(linha)) {
        adicionarEspaco(2);
        adicionarSeparador();
        adicionarTexto({
          texto: 'FORMAS DE PAGAMENTO',
          tamanho: 9.5,
          estilo: 'bold',
          alinhamento: 'center',
          alturaLinha: 4.5,
        });
        adicionarSeparador();
        adicionarEspaco(1);
        return;
      }

      if (indicePagamento > -1 && index > indicePagamento && (indiceVendedor === -1 || index < indiceVendedor)) {
        const partes = linha.split(':');

        if (partes.length >= 2) {
          const rotulo = partes.shift().trim();
          const valor = partes.join(':').trim();

          elementos.push({
            tipo: 'linhaValor',
            rotulo,
            valor,
            tamanho: 9,
            estiloRotulo: 'normal',
            estiloValor: 'bold',
          });
          return;
        }
      }

      if (/^Vendedor:/i.test(linha)) {
        adicionarEspaco(1.5);
        adicionarSeparador();
        adicionarTexto({
          texto: linha.replace(/^Vendedor:\s*/i, 'Vendedor: '),
          tamanho: 8.5,
          estilo: 'bold',
        });
        return;
      }

      // Resumo / totais
      if (/^Qtd\. total de itens/i.test(linha)) {
        adicionarEspaco(1.5);
        adicionarSeparador();
        const valor = linha.replace(/^Qtd\. total de itens\s*/i, '').trim();
        elementos.push({
          tipo: 'linhaValor',
          rotulo: 'Qtd. total de itens',
          valor,
          tamanho: 9,
          estiloRotulo: 'normal',
          estiloValor: 'bold',
        });
        return;
      }

      if (/^Valor Pedido:/i.test(linha)) {
        const valor = linha.replace(/^Valor Pedido:\s*/i, '').trim();
        elementos.push({
          tipo: 'linhaValor',
          rotulo: 'Valor Pedido',
          valor,
          tamanho: 9,
          estiloRotulo: 'normal',
          estiloValor: 'bold',
        });
        return;
      }

      if (/^Frete:/i.test(linha)) {
        const valor = linha.replace(/^Frete:\s*/i, '').trim();
        elementos.push({
          tipo: 'linhaValor',
          rotulo: 'Frete',
          valor,
          tamanho: 9,
          estiloRotulo: 'normal',
          estiloValor: 'bold',
        });
        return;
      }

      if (/^Valor Total:/i.test(linha)) {
        const valor = linha.replace(/^Valor Total:\s*/i, '').trim();
        adicionarEspaco(1);
        elementos.push({
          tipo: 'linhaValor',
          rotulo: 'TOTAL',
          valor,
          tamanho: 10.5,
          estiloRotulo: 'bold',
          estiloValor: 'bold',
        });
        return;
      }

      // Linha do item: quantidade / unitário / descontos / total
      if (/^\d+(?:[.,]\d+)?\s+UN\s*[×xX]/.test(linha)) {
        const totalMatch = linha.match(/=\s*(R\$\s*[\d.,]+)/i);
        const quantidadeUnitario = linha.split('-')[0].trim();

        adicionarTexto({
          texto: quantidadeUnitario,
          tamanho: 9,
          estilo: 'bold',
          alturaLinha: 4,
        });

        if (totalMatch) {
          elementos.push({
            tipo: 'linhaValor',
            rotulo: 'Total item',
            valor: totalMatch[1].replace(/\s+/g, ' '),
            tamanho: 9,
            estiloRotulo: 'normal',
            estiloValor: 'bold',
          });
        }

        return;
      }

      // Nome/código de produto e texto genérico
      const pareceCodigo = /^\d{6,}$/.test(linha);
      adicionarTexto({
        texto: linha,
        tamanho: pareceCodigo ? 7.5 : 9,
        estilo: pareceCodigo ? 'normal' : 'bold',
        alturaLinha: 4,
      });
    });

    // Calcula altura final
    let alturaTotal = margem + 3;

    elementos.forEach((el) => {
      if (el.tipo === 'espaco') {
        alturaTotal += el.altura;
      } else if (el.tipo === 'separador') {
        alturaTotal += el.duplo ? 3 : 2.2;
      } else if (el.tipo === 'linhaValor') {
        alturaTotal += 4.2;
      } else if (el.tipo === 'texto') {
        const linhas = medirLinhas(
          el.texto,
          el.largura,
          el.tamanho,
          'courier',
          el.estilo
        );
        alturaTotal += Math.max(1, linhas.length) * el.alturaLinha;
      }
    });

    alturaTotal += 15;

    const alturaPapel = Math.max(
      100,
      Math.ceil(alturaTotal)
    );

    const pdf = new jsPDF({
      unit: 'mm',
      format: [larguraPapel, alturaPapel],
      orientation: 'portrait',
      compress: true,
    });

    let y = margem + 3;

    const desenharSeparador = (duplo = false) => {
      /*
       * Mantém apenas o espaçamento entre os blocos.
       * Não desenha linha gráfica nem caracteres de divisão,
       * evitando problemas de renderização em PDF térmico.
       */
      y += duplo ? 4 : 3;
    };

    elementos.forEach((el) => {
      if (el.tipo === 'espaco') {
        y += el.altura;
        return;
      }

      if (el.tipo === 'separador') {
        desenharSeparador(el.duplo);
        return;
      }

      if (el.tipo === 'linhaValor') {
        pdf.setFont('courier', el.estiloRotulo || 'normal');
        pdf.setFontSize(el.tamanho || 9);
        pdf.text(el.rotulo, margem, y);

        pdf.setFont('courier', el.estiloValor || 'bold');
        pdf.text(
          el.valor,
          larguraPapel - margem,
          y,
          { align: 'right' }
        );

        y += 4.2;
        return;
      }

      if (el.tipo === 'texto') {
        pdf.setFont('courier', el.estilo);
        pdf.setFontSize(el.tamanho);

        const linhas = pdf.splitTextToSize(
          el.texto,
          el.largura
        );

        linhas.forEach((linha) => {
          if (el.alinhamento === 'center') {
            pdf.text(linha, centro, y, { align: 'center' });
          } else if (el.alinhamento === 'right') {
            pdf.text(
              linha,
              larguraPapel - margem,
              y,
              { align: 'right' }
            );
          } else {
            pdf.text(
              linha,
              el.margemEsquerda,
              y
            );
          }

          y += el.alturaLinha;
        });
      }
    });

    pdf.save(nomeArquivo);
  };


  const baixarOrcamentoPdfDireto = async ({
    nomeArquivo,
    numero,
    dataHora,
    cliente,
    nomeVendedor,
    produtos,
    quantidadeProdutos,
    valorPedido,
    frete,
    valorTotal,
    pagamentos,
  }) => {
    const larguraPapel = 80;
    const margem = 8;
    const centro = larguraPapel / 2;
    const larguraUtil = larguraPapel - (margem * 2);
    const alturaLinha = 4;

    const medidor = new jsPDF({
      unit: 'mm',
      format: [larguraPapel, 200],
      orientation: 'portrait',
    });

    const medir = (texto, tamanho = 9, estilo = 'normal') => {
      medidor.setFont('courier', estilo);
      medidor.setFontSize(tamanho);
      return medidor.splitTextToSize(String(texto || ''), larguraUtil);
    };

    const blocos = [];

    const texto = (
      valor,
      tamanho = 9,
      estilo = 'normal',
      alinhamento = 'left',
      espacoDepois = 0
    ) => {
      blocos.push({
        tipo: 'texto',
        valor: String(valor || ''),
        tamanho,
        estilo,
        alinhamento,
        espacoDepois,
      });
    };

    const espaco = (altura = 2) => {
      blocos.push({ tipo: 'espaco', altura });
    };

    const linhaValor = (
      rotulo,
      valor,
      tamanho = 9,
      negrito = false
    ) => {
      blocos.push({
        tipo: 'linhaValor',
        rotulo,
        valor: String(valor || ''),
        tamanho,
        negrito,
      });
    };

    texto(config.restaurante.nome, 11, 'bold', 'center');
    texto(`CNPJ ${String(config.restaurante.cnpj || '').replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    )}`, 8.5, 'normal', 'center');

    texto(`IE ${config.restaurante.ie || ''}`, 8.5, 'normal', 'center');

    texto(
      `${config.restaurante.endereco.logradouro}, ${config.restaurante.endereco.numero}, ${config.restaurante.endereco.bairro}, ${config.restaurante.endereco.cidade.nome} - ${config.restaurante.endereco.cidade.estado}`,
      8.5,
      'normal',
      'center'
    );

    if (config.restaurante.telefone) {
      texto(
        formatPhoneNumber(config.restaurante.telefone) || '',
        8.5,
        'normal',
        'center'
      );
    }

    espaco(1.5);
    texto(dataHora, 8.5, 'normal', 'center');
    espaco(2);

    if (cliente) {
      texto(`Cliente: ${cliente}`, 8.5, 'bold');
      espaco(1);
    }

    texto(`ORÇAMENTO ${numero}`, 11, 'bold', 'center');
    texto('CUPOM SEM VALOR FISCAL', 8.5, 'bold', 'center');
    espaco(2);

    produtos.forEach((produto, index) => {
      if (produto.codigo) {
        texto(produto.codigo, 7.5, 'normal');
      }

      texto(produto.nome, 9, 'bold');

      texto(
        `${produto.quantidade} UN x ${produto.valorUnitario}`,
        9,
        'bold'
      );

      if (produto.desconto !== 'R$ 0,00') {
        linhaValor('Desconto', produto.desconto, 8.5, false);
      }

      if (produto.acrescimo !== 'R$ 0,00') {
        linhaValor('Acréscimo', produto.acrescimo, 8.5, false);
      }

      linhaValor('Total item', produto.total, 9, true);

      if (index < produtos.length - 1) {
        espaco(2);
      }
    });

    espaco(2);
    linhaValor(
      'Qtd. total de itens',
      String(quantidadeProdutos),
      9,
      true
    );
    linhaValor('Valor Pedido', valorPedido, 9, true);
    linhaValor('Frete', frete, 9, true);
    espaco(1);
    linhaValor('TOTAL', valorTotal, 10.5, true);

    espaco(3);
    texto('FORMAS DE PAGAMENTO', 9.5, 'bold', 'center');
    espaco(1);

    pagamentos.forEach((pagamento) => {
      linhaValor(
        pagamento.forma,
        pagamento.valor,
        9,
        true
      );
    });

    espaco(4);

    texto('.', 8.5, 'bold');



    let alturaTotal = margem + 3;

    blocos.forEach((bloco) => {
      if (bloco.tipo === 'espaco') {
        alturaTotal += bloco.altura;
        return;
      }

      if (bloco.tipo === 'linhaValor') {
        alturaTotal += 4.2;
        return;
      }

      const linhas = medir(
        bloco.valor,
        bloco.tamanho,
        bloco.estilo
      );

      alturaTotal +=
        Math.max(1, linhas.length) * alturaLinha +
        bloco.espacoDepois;
    });

    alturaTotal += 15;

    const pdf = new jsPDF({
      unit: 'mm',
      format: [
        larguraPapel,
        Math.max(100, Math.ceil(alturaTotal)),
      ],
      orientation: 'portrait',
      compress: true,
    });

    let y = margem + 3;

    blocos.forEach((bloco) => {
      if (bloco.tipo === 'espaco') {
        y += bloco.altura;
        return;
      }

      if (bloco.tipo === 'linhaValor') {
        pdf.setFont(
          'courier',
          bloco.negrito ? 'bold' : 'normal'
        );
        pdf.setFontSize(bloco.tamanho);

        pdf.text(bloco.rotulo, margem, y);

        pdf.setFont('courier', 'bold');
        pdf.text(
          bloco.valor,
          larguraPapel - margem,
          y,
          { align: 'right' }
        );

        y += 4.2;
        return;
      }

      pdf.setFont('courier', bloco.estilo);
      pdf.setFontSize(bloco.tamanho);

      const linhas = pdf.splitTextToSize(
        bloco.valor,
        larguraUtil
      );

      linhas.forEach((linha) => {
        if (bloco.alinhamento === 'center') {
          pdf.text(linha, centro, y, { align: 'center' });
        } else if (bloco.alinhamento === 'right') {
          pdf.text(
            linha,
            larguraPapel - margem,
            y,
            { align: 'right' }
          );
        } else {
          pdf.text(linha, margem, y);
        }

        y += alturaLinha;
      });

      y += bloco.espacoDepois;
    });

    pdf.save(nomeArquivo);
  };

  const imprimirOrcamento = async () => {
    for (const pagamento of pagItem) {
      if (pagamento.tPag === '05') {
        console.log(pagamento.tPag);
        window.alert('Não é possível utilizar CRÉDITO LOJA em orçamento.');
        return;
      }
    }

    console.log('imprimirOrcamento');
    setLoading(true);
    const detItemArray = Array();
    let vBC_ttlnfe = 0;
    let vICMS_ttlnfe = 0;
    let vFrete_ttlnfe = 0;
    let vDesc_ttlnfe = 0;
    let vOutro_ttlnfe = 0;
    let vProd_ttlnfe = 0;
    let valorTotal = 0;
    produtos.map(produto => {
      // Fake enquanto não vem do produto
      produto.indTot = '1';
      //produto.frete = 0;
      // Somar frete de todos os produtos
      console.log(vFrete_ttlnfe);
      console.log(produto.frete);
      vFrete_ttlnfe += produto.frete ? parseFloat(produto.frete) : 0;
      vDesc_ttlnfe += parseFloat(produto.valorDesconto);
      vOutro_ttlnfe += parseFloat(produto.valorAcrescimo);

      if (produto.indTot === '1') {
        vProd_ttlnfe += produto.quantidade * produto.preco;
      }

      let icms = {
        orig: `${produto.origem}`,
        CST: `${produto.cst}`,
        vBC: '0',
      };
      if (
        produto.cst === '00' ||
        produto.cst === '10' ||
        produto.cst === '20' ||
        produto.cst === '30' ||
        produto.cst === '70' ||
        produto.cst === '90' ||
        produto.cst === '900'
      ) {
        /*0 - Margem Valor Agregado (%);
          1 - Pauta (Valor);
          2 - Preço Tabelado Máx. (valor);
          3 - Valor da operação.*/
        icms.modBC = '0'; //incluir esse campo só com CST = 00, 10, 20, 30, 70 e 90. Com CSOSN = 900
        icms.vBC = `${produto.quantidade * produto.preco +
          produto.valorAcrescimo -
          produto.valorDesconto
          }`; //vBC = vProd + vOutros -vDesc por item
        icms.pICMS = '0'; //pICMS Alíquota do Imposto - zero (incluir esse campo só com CST = 00, 10, 20, 30, 70 e 90. Com CSOSN = 900)
        icms.vICMS_icms = (0 / 100) * icms.vBC; //vICMS_icms = (pICMS/100) * vBC (incluir esse campo só com CST = 00, 10, 20, 30, 70 e 90. Com CSOSN = 900)

        vBC_ttlnfe += icms.vBC;
        vICMS_ttlnfe += (0 / 100) * (produto.quantidade * produto.preco);
      }
      console.log(produto);

      let item = {
        infADProd: '',
        prod: {
          cProd: `${produto.id}`,
          cEAN: `${produto.ean}`,
          xProd:
            config.tpAmb === '2'
              ? 'NOTA FISCAL EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
              : trataXProd(produto.nome, produto.observacao),
          NCM: `${produto.ncm}`,
          CFOP: `${produto.cfop}`,
          uCOM: `${produto.unidade}`,
          qCOM: `${produto.quantidade}`,
          vUnCom: `${produto.preco}`,
          vProd: `${produto.quantidade * produto.preco}`,
          cEANTrib: `${produto.ean ? produto.ean : 'SEM GTIN'}`,
          uTrib: `${produto.unidade}`,
          qTrib: `${produto.quantidade}`,
          vUnTrib: `${produto.preco}`,
          indTot: `${produto.indTot}`,
          nTipoItem: `${produto.ntipoItem}`,
          vFrete: `${produto.frete ? produto.frete : '0'}`,
          vDesc: `${parseFloat(produto.valorDesconto).toFixed(2)}`,
          CEST: '',
          vOutro_item: `${parseFloat(produto.valorAcrescimo).toFixed(2)}`,
          observacao: `${produto.observacao || ''}`,
          idVendedor: `${produto.idVendedor || ''}`
        },
        imposto: {
          ICMS: icms,
          PIS: { CST_pis: '07' },
          COFINS: { CST_cofins: '07' },
          vTotTrib: '0',
        },
      };




      detItemArray.push(item);
    });
    valorTotal = (
      // vBC_ttlnfe +
      //   vICMS_ttlnfe +
      vProd_ttlnfe +
      vFrete_ttlnfe -
      vDesc_ttlnfe +
      vOutro_ttlnfe
    ).toFixed(2);

    const numeroDoOrcamentoOuPedido = gerarCodigoComData();
    var orcamento = {
      ModeloDocumento: 'NFCe',
      Versao: '4.0',
      identificador: numeroDoOrcamentoOuPedido,
      ide: {
        cNF: '00000001',
        cUF: config.restaurante.endereco.cidade.cuf,
        natOp: 'Venda',
        indPag: '0',
        mod: '65',
        serie: '124',
        nNF: '',
        dhEmi: '',
        fusoHorario: '-03:00',
        tpNf: '1',
        idDest: '1',
        indFinal: '1',
        indPres: '1',
        cMunFg: config.restaurante.endereco.cidade.ibge,
        tpImp: '4',
        tpEmis: '1',
        tpAmb: config.tpAmb,
        finNFe: '1',
        procEmi: '0',
      },
      emit: {
        CNPJ_emit: config.restaurante.cnpj,
        xNome: config.restaurante.nome,
        IE: config.restaurante.ie,
        CRT: config.restaurante.crt,
        enderEmit: {
          xLgr: config.restaurante.endereco.logradouro,
          nro: config.restaurante.endereco.numero,
          xBairro: config.restaurante.endereco.bairro,
          cMun: config.restaurante.endereco.cidade.ibge,
          xMun: config.restaurante.endereco.cidade.nome,
          UF: config.restaurante.endereco.cidade.estado,
          CEP: config.restaurante.endereco.cep,
        },
      },
      dest: {
        CPF_dest:
          config.tpAmb === '2' ? '39247350859' : documentoCupom ? documentoCupom : '',
        indIEDest: config.tpAmb === '2' ? '9' : documentoCupom ? '9' : '0',
        xNome_dest:
          config.tpAmb === '2'
            ? 'NF-E EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
            : documentoCupom
              ? nomeCupom
                ? nomeCupom
                : 'Consumidor Identificado'
              : '',

        enderDest: {
          nro_dest: consumidor?.endereco?.numero || null,
          xBairro_dest: consumidor?.endereco?.bairro || null,
          xEmail_dest: emailNota ? emailNota : consumidor?.email || null,
          xLgr_dest: consumidor?.endereco?.logradouro || null,
          cMun_dest: consumidor?.endereco?.cidade?.ibge || null,
          xMun_dest: consumidor?.endereco?.cidade?.nome || null,
          UF_dest: consumidor?.endereco?.ufEstado || null,
          CEP_dest: consumidor?.endereco?.cep || null,
        },
      },
      det: {
        detItem: detItemArray,
      },
      total: {
        ICMStot: {
          //Informar o somatório do campo vBC de item produto com CST = 00, 10, 20, 30, 70 e 90.
          // Com CSOSN = 900. NT2011.004
          vBC_ttlnfe: parseFloat(vBC_ttlnfe).toFixed(2),
          vICMS_ttlnfe: vICMS_ttlnfe.toFixed(2),
          vICMSDeson_ttlnfe: '0.00',
          vBCST_ttlnfe: '0.00',
          vST_ttlnfe: '0.00',
          vProd_ttlnfe: vProd_ttlnfe.toFixed(2),
          vFrete_ttlnfe: vFrete_ttlnfe.toFixed(2),
          vSeg_ttlnfe: '0.00',
          vDesc_ttlnfe: vDesc_ttlnfe.toFixed(2),
          vIPI_ttlnfe: '0.00',
          vPIS_ttlnfe: '0.00',
          vCOFINS_ttlnfe: '0.00',
          vOutro: vOutro_ttlnfe.toFixed(2),
          vNF: valorTotal,
          vTotTrib_ttlnfe: '0.00',
        },
      },
      transp: {
        modFrete: '9',
      },
      pag: {
        pagItem: pagItem,
      },
      InfoSistema: {
        chaveDocFiscal: '',
        numeroDocFiscal: '',
        serieDocFiscal: '',
      },
      nomeCupom: nomeCupom || ''
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };

    const agora = new Date();
    const ano = agora.getFullYear();
    const mes = (agora.getMonth() + 1).toString().padStart(2, '0');
    const dia = agora.getDate().toString().padStart(2, '0');
    const hora = agora.getHours().toString().padStart(2, '0');
    const minuto = agora.getMinutes().toString().padStart(2, '0');
    const segundo = agora.getSeconds().toString().padStart(2, '0');

    const dataHoraFormatada = `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
    orcamento.InfoSistema.chaveDocFiscal = '';
    orcamento.InfoSistema.numeroDocFiscal = '';
    orcamento.InfoSistema.serieDocFiscal = '';
    orcamento.InfoSistema.idVendedorOrcamento = idVendedorOrcamento ? idVendedorOrcamento : idUser;

    // Criando uma string com o formato desejado (YYYY-MM-DDTHH:MM:SS-03:00)
    const dataHoraFormatada2 = `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}-03:00`;
    orcamento.InfoSistema.docDhAut = dataHoraFormatada2;

    const response = await (idOrcamento !== null && idOrcamento !== ''
      ? axios.put(
        `${api.techspdv}/v1/pdveventos/orcamento/${idOrcamento}`,
        orcamento,
        options,
      )
      : axios.post(
        `${api.techspdv}/v1/pdveventos/orcamento`,
        orcamento,
        options,
      )
    ).catch(error => {
      // Tratar erros aqui
      if (error.response) {
        // A solicitação foi feita e o servidor respondeu com um status de erro
        console.log('Status de erro:', error.response.status);
        console.log('Dados de erro:', error.response.data);
        //window.alert(error.response.data.detail);
        /*window.alert(
          'Deseja tentar novamente o Orçamento?',
          [
            {
              text: 'Não',
              onPress: () => {
                setLoading(false);
                closeModal();
                setProdutos([]);
                setConsumidor(null);
                setNomeCupom('');
                setDocumentoCupom('');
                setConsumidorIdentificado(false);
              },
            },
            {
              text: 'Sim',
              onPress: () => console.log('Continuar'),
            },
          ],
          {cancelable: false},
        );*/
        setLoading(false);
        return;
      } else if (error.request) {
        // A solicitação foi feita, mas não recebeu resposta
        console.error('Não recebeu resposta');
      } else {
        // Ocorreu um erro ao configurar a solicitação
        console.error('Erro ao configurar a solicitação:', error.message);
      }
    });

    if (response.status == 201) {
      let produtosString = ``;
      var stringPagamento = '<br>FORMAS DE PAGAMENTO<br>';
      orcamento.pag.pagItem.map(pagamento => {
        stringPagamento += `${pagamento.xPag}:  ${formatarValor(pagamento.vPag)}<br>`;
      });

      var quantidadeProdutos = 0;
      var totalProduto = 0;
      detItemArray.map(produto => {
        totalProduto = (
          parseFloat(produto.prod.qTrib) *
          (parseFloat(produto.prod.vUnCom) -
            parseFloat(produto.prod.vDesc) +
            parseFloat(produto.prod.vOutro_item)
          )
        ).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        console.log(produto.prod.vFrete);

        quantidadeProdutos += parseFloat(produto.prod.qTrib);


        const qtdeFormatada = formatarQuantidade(produto.prod.qTrib);
        const valorUnitario = formatarValor(produto.prod.vUnCom);
        const desconto = formatarValor(produto.prod.vDesc);
        const outros = formatarValor(produto.prod.vOutro_item);
        const total = formatarValor(totalProduto);
        console.log(config.terminalComercial?.suprimirCodigos);
        console.log(config.terminalComercial?.suprimirCodigos == false);
        console.log(config.terminalComercial?.suprimirCodigos === false);
        const codigo = config.terminalComercial?.suprimirCodigos ? '' : (obterCodigoProdutoNota(produto, config))


        produtosString += `
        ${codigo}<br>
        ${produto.prod.xProd}<br>
        ${qtdeFormatada} UN × ${valorUnitario} 
        - ${desconto} + ${outros} = ${total}<br><br>
    `;
      });


      function centralizeText(text, columnWidth) {
        const totalSpaces = columnWidth - text.length;
        const leftSpaces = Math.max(0, Math.floor(totalSpaces / 2));
        const rightSpaces = Math.ceil(totalSpaces / 2);

        /*  const centeredText =
          ' '.repeat(leftSpaces) + text + ' '.repeat(rightSpaces);*/
        const centeredText = text;
        return ' '.repeat(leftSpaces) + text;
      }
      const cupomWidth = 33;
      //const cupom = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
      const enderecoAux = centralizeText(
        `${config.restaurante.endereco.logradouro}, ${config.restaurante.endereco.numero}, ${config.restaurante.endereco.bairro}, ${config.restaurante.endereco.cidade.nome} - ${config.restaurante.endereco.cidade.estado}`,
        cupomWidth,
      );

      const nomeVendedor =
        await buscarNomeVendedor(
          response?.data?.idVendedor || idVendedorOrcamento || idUser
        ) || '';

      const produtosPdf = detItemArray.map((produto) => {
        const totalItem =
          parseFloat(produto.prod.qTrib) *
          (
            parseFloat(produto.prod.vUnCom) -
            parseFloat(produto.prod.vDesc) +
            parseFloat(produto.prod.vOutro_item)
          );

        const codigo =
          config.terminalComercial?.suprimirCodigos
            ? ''
            : (
              obterCodigoProdutoNota(produto, config)
            )


        return {
          codigo,
          nome: produto.prod.xProd,
          quantidade: formatarQuantidade(
            produto.prod.qTrib
          ),
          valorUnitario: formatarValor(
            produto.prod.vUnCom
          ),
          desconto: formatarValor(
            produto.prod.vDesc
          ),
          acrescimo: formatarValor(
            produto.prod.vOutro_item
          ),
          total: formatarValor(totalItem),
        };
      });

      const pagamentosPdf = (orcamento.pag.pagItem || [])
        .map((pagamento) => ({
          forma: pagamento.xPag,
          valor: formatarValor(pagamento.vPag),
        }));

      try {
        const personalizacaoOrcamento = obterPersonalizacao('orcamento');
        const nomeArquivo = `${personalizacaoOrcamento.prefixo}_ORCAMENTO_${numeroDoOrcamentoOuPedido}.pdf`;

        if (personalizacaoOrcamento.html) {
          // Futuramente, substituir as mascaras antes da conversao.
          await baixarCupomPdf(personalizacaoOrcamento.html, nomeArquivo);
        } else {
          await baixarOrcamentoPdfDireto({
            nomeArquivo,
            numero: numeroDoOrcamentoOuPedido,
            dataHora: dataHoraFormatada,
            cliente: nomeCupom || '',
            nomeVendedor,
            produtos: produtosPdf,
            quantidadeProdutos,
            valorPedido: parseFloat(
              (valorTotal - (vFrete_ttlnfe || 0)) || '0'
            ).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
            frete: parseFloat(
              vFrete_ttlnfe || '0'
            ).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
            valorTotal: parseFloat(
              valorTotal
            ).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
            pagamentos: pagamentosPdf,
          });
        }
      } catch (error) {
        console.error(error);
        window.alert(
          'Ocorreu um erro ao tentar baixar o orçamento em PDF: ' +
          error.message
        );
      }

      setLoading(false);
      setVendaPuxada(false);
      closeModal();
      setProdutos([]);
      setConsumidor(null);
      setNomeCupom('');
      setDocumentoCupom('');
      setConsumidorIdentificado(false);
      setPagItem(null);
      focarCodigoDeBarras();
    }
  };

  const imprimirPedido = async () => {
    console.log('imprimirPedido');
    setLoading(true);
    const detItemArray = Array();
    let vBC_ttlnfe = 0;
    let vICMS_ttlnfe = 0;
    let vFrete_ttlnfe = 0;
    let vDesc_ttlnfe = 0;
    let vOutro_ttlnfe = 0;
    let vProd_ttlnfe = 0;
    let valorTotal = 0;
    produtos.map(produto => {
      // Fake enquanto não vem do produto
      produto.indTot = '1';
      //produto.frete = 0;
      // Somar frete de todos os produtos
      console.log(vFrete_ttlnfe);
      console.log(produto.frete);
      vFrete_ttlnfe += produto.frete ? parseFloat(produto.frete) : 0;
      vDesc_ttlnfe += parseFloat(produto.valorDesconto);
      vOutro_ttlnfe += parseFloat(produto.valorAcrescimo);

      if (produto.indTot === '1') {
        vProd_ttlnfe += produto.quantidade * produto.preco;
      }

      let icms = {
        orig: `${produto.origem}`,
        CST: `${produto.cst}`,
        vBC: '0',
      };
      if (
        produto.cst === '00' ||
        produto.cst === '10' ||
        produto.cst === '20' ||
        produto.cst === '30' ||
        produto.cst === '70' ||
        produto.cst === '90' ||
        produto.cst === '900'
      ) {
        /*0 - Margem Valor Agregado (%);
          1 - Pauta (Valor);
          2 - Preço Tabelado Máx. (valor);
          3 - Valor da operação.*/
        icms.modBC = '0'; //incluir esse campo só com CST = 00, 10, 20, 30, 70 e 90. Com CSOSN = 900
        icms.vBC = `${produto.quantidade * produto.preco +
          produto.valorAcrescimo -
          produto.valorDesconto
          }`; //vBC = vProd + vOutros -vDesc por item
        icms.pICMS = '0'; //pICMS Alíquota do Imposto - zero (incluir esse campo só com CST = 00, 10, 20, 30, 70 e 90. Com CSOSN = 900)
        icms.vICMS_icms = (0 / 100) * icms.vBC; //vICMS_icms = (pICMS/100) * vBC (incluir esse campo só com CST = 00, 10, 20, 30, 70 e 90. Com CSOSN = 900)

        vBC_ttlnfe += icms.vBC;
        vICMS_ttlnfe += (0 / 100) * (produto.quantidade * produto.preco);
      }

      const item = {
        infADProd: '',
        prod: {
          cProd: `${produto.id}`,
          cEAN: `${produto.ean}`,
          xProd:
            config.tpAmb === '2'
              ? 'NOTA FISCAL EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
              : trataXProd(produto.nome, produto.observacao),
          NCM: `${produto.ncm}`,
          CFOP: `${produto.cfop}`,
          uCOM: `${produto.unidade}`,
          qCOM: `${produto.quantidade}`,
          vUnCom: `${produto.preco}`,
          vProd: `${produto.quantidade * produto.preco}`,
          cEANTrib: `${produto.ean ? produto.ean : 'SEM GTIN'}`,
          uTrib: `${produto.unidade}`,
          qTrib: `${produto.quantidade}`,
          vUnTrib: `${produto.preco}`,
          indTot: `${produto.indTot}`,
          nTipoItem: `${produto.ntipoItem}`,
          vFrete: `${produto.frete ? produto.frete : '0'}`,
          vDesc: `${parseFloat(produto.valorDesconto).toFixed(2)}`,
          CEST: '',
          vOutro_item: `${parseFloat(produto.valorAcrescimo).toFixed(2)}`,
          observacao: `${produto.observacao || ''}`,
          idVendedor: `${habilitarSelecaoVendedor && usuarioSelecionado
            ? usuarioSelecionado : produto.idVendedor || ''}`
        },
        imposto: {
          ICMS: icms,
          PIS: { CST_pis: '07' },
          COFINS: { CST_cofins: '07' },
          vTotTrib: '0',
        },
      };
      detItemArray.push(item);
    });
    valorTotal = (
      //vBC_ttlnfe +
      //vICMS_ttlnfe +
      vProd_ttlnfe +
      vFrete_ttlnfe -
      vDesc_ttlnfe +
      vOutro_ttlnfe
    ).toFixed(2);

    console.log(
      vBC_ttlnfe + vICMS_ttlnfe + vProd_ttlnfe + vFrete_ttlnfe
        ? vFrete_ttlnfe
        : 0 - vDesc_ttlnfe + vOutro_ttlnfe,
    );
    console.log(vDesc_ttlnfe);
    console.log(vBC_ttlnfe);
    const numeroDoOrcamentoOuPedido = gerarCodigoComData();
    var pedido = {
      ModeloDocumento: 'NFCe',
      identificador: numeroDoOrcamentoOuPedido,
      Versao: '4.0',
      ide: {
        cNF: '00000001',
        cUF: config.restaurante.endereco.cidade.cuf,
        natOp: 'Venda',
        indPag: '0',
        mod: '65',
        serie: '124',
        nNF: '',
        dhEmi: '',
        fusoHorario: '-03:00',
        tpNf: '1',
        idDest: '1',
        indFinal: '1',
        indPres: '1',
        cMunFg: config.restaurante.endereco.cidade.ibge,
        tpImp: '4',
        tpEmis: '1',
        tpAmb: config.tpAmb,
        finNFe: '1',
        procEmi: '0',
      },
      emit: {
        CNPJ_emit: config.restaurante.cnpj,
        xNome: config.restaurante.nome,
        IE: config.restaurante.ie,
        CRT: config.restaurante.crt,
        enderEmit: {
          xLgr: config.restaurante.endereco.logradouro,
          nro: config.restaurante.endereco.numero,
          xBairro: config.restaurante.endereco.bairro,
          cMun: config.restaurante.endereco.cidade.ibge,
          xMun: config.restaurante.endereco.cidade.nome,
          UF: config.restaurante.endereco.cidade.estado,
          CEP: config.restaurante.endereco.cep,
        },
      },
      dest: {
        CPF_dest:
          config.tpAmb === '2' ? '39247350859' : documentoCupom ? documentoCupom : '',
        indIEDest: config.tpAmb === '2' ? '9' : documentoCupom ? '9' : '0',
        xNome_dest:
          config.tpAmb === '2'
            ? 'NF-E EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
            : documentoCupom
              ? nomeCupom
                ? nomeCupom
                : 'Consumidor Identificado'
              : '',

        enderDest: {
          nro_dest: consumidor?.endereco?.numero || null,
          xBairro_dest: consumidor?.endereco?.bairro || null,
          xEmail_dest: emailNota ? emailNota : consumidor?.email || null,
          xLgr_dest: consumidor?.endereco?.logradouro || null,
          cMun_dest: consumidor?.endereco?.cidade?.ibge || null,
          xMun_dest: consumidor?.endereco?.cidade?.nome || null,
          UF_dest: consumidor?.endereco?.ufEstado || null,
          CEP_dest: consumidor?.endereco?.cep || null,
        },
      },

      det: {
        detItem: detItemArray,
      },
      total: {
        ICMStot: {
          //Informar o somatório do campo vBC de item produto com CST = 00, 10, 20, 30, 70 e 90.
          // Com CSOSN = 900. NT2011.004
          vBC_ttlnfe: parseFloat(vBC_ttlnfe).toFixed(2),
          vICMS_ttlnfe: vICMS_ttlnfe.toFixed(2),
          vICMSDeson_ttlnfe: '0.00',
          vBCST_ttlnfe: '0.00',
          vST_ttlnfe: '0.00',
          vProd_ttlnfe: vProd_ttlnfe.toFixed(2),
          vFrete_ttlnfe: vFrete_ttlnfe.toFixed(2),
          vSeg_ttlnfe: '0.00',
          vDesc_ttlnfe: vDesc_ttlnfe.toFixed(2),
          vIPI_ttlnfe: '0.00',
          vPIS_ttlnfe: '0.00',
          vCOFINS_ttlnfe: '0.00',
          vOutro: vOutro_ttlnfe.toFixed(2),
          vNF: valorTotal,
          vTotTrib_ttlnfe: '0.00',
        },
      },
      transp: {
        modFrete: '9',
      },
      pag: {
        pagItem: pagItem,
      },
      InfoSistema: {
        chaveDocFiscal: '',
        numeroDocFiscal: '',
        serieDocFiscal: '',
      },
      nomeCupom: nomeCupom || ''
    };
    console.log(pedido);




    if (config?.terminalComercial?.gerenciaEstoque == true && config?.terminalComercial?.venderZerado == false) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      try {
        const validarProdutos = await axios.post(
          `${api.techspdv}/v1/restaurantes/${config.restaurante.id}/produtos/validarEstoque`,
          detItemArray,
          options
        );
        console.log(validarProdutos);
      } catch (error) {


        // Verifica se a resposta tem um status 400 e trata adequadamente
        if (error.response?.status === 400) {
          console.error(error.response.data || "Erro ao validar produtos!");
          message.error(error.response.data || "Erro ao validar produtos!");
          setLoading(false);
          return;
        } else {
          console.log(error);
          console.error("Falha na comunicação com o servidor!");
          message.error("Falha na comunicação com o servidor!");
          setLoading(false);
          return;
        }
      }
    }


    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
    const agora = new Date();
    const ano = agora.getFullYear();
    const mes = (agora.getMonth() + 1).toString().padStart(2, '0');
    const dia = agora.getDate().toString().padStart(2, '0');
    const hora = agora.getHours().toString().padStart(2, '0');
    const minuto = agora.getMinutes().toString().padStart(2, '0');
    const segundo = agora.getSeconds().toString().padStart(2, '0');

    const dataHoraFormatada = `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
    pedido.InfoSistema.chaveDocFiscal = '';
    pedido.InfoSistema.numeroDocFiscal = '';
    pedido.InfoSistema.serieDocFiscal = '';
    pedido.InfoSistema.idVendedorOrcamento = idVendedorOrcamento || '';
    pedido.InfoSistema.idOrcamento = idOrcamento || '';

    // Criando uma string com o formato desejado (YYYY-MM-DDTHH:MM:SS-03:00)
    const dataHoraFormatada2 = `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}-03:00`;
    pedido.InfoSistema.docDhAut = dataHoraFormatada2;

    tipoTela === "Pedidos" &&
      (pedido.InfoSistema.sessaoDeCaixa = sessaoCaixa?.id || null);

    console.log(pedido);
    const response = await axios
      .post(
        `${api.techspdv}/v1/pdveventos/pedido`,
        pedido,
        options,
      )
      .catch(error => {
        // Tratar erros aqui
        if (error.response) {
          // A solicitação foi feita e o servidor respondeu com um status de erro
          console.log('Status de erro:', error.response.status);
          console.log('Dados de erro:', error.response.data);
          //window.alert(error.response.data.detail);
          /* Alert.alert(
             'Falha ao gravar o pedido.',
             'Deseja continuar o Pedido?',
             [
               {
                 text: 'Não',
                 onPress: () => {
                   setLoading(false);
                   closeModal();
                   setProdutos([]);
                   setConsumidor(null);
                   setNomeCupom('');
                   setDocumentoCupom('');
                   setConsumidorIdentificado(false);
                 },
               },
               {
                 text: 'Sim',
                 onPress: () => console.log('Continuar'),
               },
             ],
             {cancelable: false},
           );*/
          setLoading(false);
          return;
        } else if (error.request) {
          // A solicitação foi feita, mas não recebeu resposta
          console.error('Não recebeu resposta');
        } else {
          // Ocorreu um erro ao configurar a solicitação
          console.error('Erro ao configurar a solicitação:', error.message);
        }
      });

    console.log(response.status);
    if (response.status == 201) {
      console.log(response.data);
      let produtosString = ``;
      var stringPagamento = 'FORMAS DE PAGAMENTO<br>';
      pedido.pag.pagItem.map(pagamento => {
        stringPagamento += `${pagamento.xPag}:  ${formatarValor(pagamento.vPag)}<br>`;
      });

      var quantidadeProdutos = 0;
      var totalProduto = 0;
      detItemArray.map(produto => {
        totalProduto =
          parseFloat(produto.prod.qTrib) *
          (parseFloat(produto.prod.vUnCom) -
            parseFloat(produto.prod.vDesc) +
            parseFloat(produto.prod.vOutro_item));


        quantidadeProdutos += parseFloat(produto.prod.qTrib);

        const qtdeFormatada = formatarQuantidade(produto.prod.qTrib);
        const valorUnitario = formatarValor(produto.prod.vUnCom);
        const desconto = formatarValor(produto.prod.vDesc);
        const outros = formatarValor(produto.prod.vOutro_item);
        const total = formatarValor(totalProduto);

        const codigo = config.terminalComercial?.suprimirCodigos ? '' : (
          produto.prod.cEANTrib &&
          produto.prod.cEANTrib !== 'SEM GTIN')
          ? produto.prod.cEANTrib
          : produto.prod.cProd;

        produtosString += `
        ${codigo}<br>
        ${produto.prod.xProd}<br>
        ${qtdeFormatada} UN × ${valorUnitario} 
        - ${desconto} + ${outros} = ${total}<br><br>
    `;

      });

      function centralizeText(text, columnWidth) {
        const totalSpaces = columnWidth - text.length;
        const leftSpaces = Math.max(0, Math.floor(totalSpaces / 2));
        const rightSpaces = Math.ceil(totalSpaces / 2);

        /*  const centeredText =
          ' '.repeat(leftSpaces) + text + ' '.repeat(rightSpaces);*/
        const centeredText = text;
        return ' '.repeat(leftSpaces) + text;
      }
      const cupomWidth = 33;
      //const cupom = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
      const enderecoAux = centralizeText(
        `${config.restaurante.endereco.logradouro}, ${config.restaurante.endereco.numero}, ${config.restaurante.endereco.bairro}, ${config.restaurante.endereco.cidade.nome} - ${config.restaurante.endereco.cidade.estado}`,
        cupomWidth,
      );
      console.log('antes de buscar vendedor');
      const nomeVendedor = await buscarNomeVendedor(habilitarSelecaoVendedor && usuarioSelecionado
        ? usuarioSelecionado : response?.data?.idVendedor) || '';
      const htmlPadrao = `
    <html>
      <head>
        <meta charset="utf-8">
        <title>Cupom</title>
        <style>
          body {
            font-family: monospace;
            font-size: 10pt;
          }
        </style>
      </head>
      <body>
        ${config.restaurante.nome}<br>
        CNPJ - ${config.restaurante.cnpj}<br>
        IE - ${config.restaurante.ie}<br>
        ${enderecoAux}<br>
        ${config.restaurante.telefone ? formatPhoneNumber(config.restaurante.telefone) : ''}<br><br>
        ${dataHoraFormatada}<br>
        <br>
        Cliente:${nomeCupom || ''}
        <br><br>
        PEDIDO ${numeroDoOrcamentoOuPedido}<br><br>
        CUPOM SEM VALOR FISCAL<br><br>
        ${produtosString}<br>
        Qtd. total de itens ${quantidadeProdutos}
      <br>
         Valor Pedido:${parseFloat((valorTotal - (vFrete_ttlnfe) || 0) || '0').toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}
        <br>
         Frete:${parseFloat(vFrete_ttlnfe || '0').toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}
        <br>
        Valor Total: ${parseFloat(valorTotal).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}<br><br>${stringPagamento}
        <br><br>
        Vendedor:${nomeVendedor}
        <br>
        <br>
        <br>
        <span>.</span>
      </body>
    </html>
  `;


      const personalizacaoPedido = obterPersonalizacao('pedido');
      const htmlContent = personalizacaoPedido.html || htmlPadrao;
      const nomeArquivo = `${personalizacaoPedido.prefixo}_PEDIDO_${numeroDoOrcamentoOuPedido}.pdf`;
      console.log(htmlContent);

      try {
        await baixarCupomPdf(htmlContent, nomeArquivo);
      } catch (error) {
        console.error(error);
        window.alert(
          'Ocorreu um erro ao tentar baixar o pedido em PDF: ' +
          error.message
        );
      }


      setLoading(false);
      setVendaPuxada(false);
      closeModal();
      setProdutos([]);
      setConsumidor(null);
      setNomeCupom('');
      setDocumentoCupom('');
      setConsumidorIdentificado(false);
      setPagItem(null);
      focarCodigoDeBarras();

    }
  };

  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      axios
        .get(
          `${api.techfood}/v1/restaurantes/usuario/${idUser}`,
          options,
        )
        .then(async restaurante => {
          setLoja(restaurante.data);
          try {
            const options = {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + accessToken,
              },
            };
            const response2 = await axios.get(
              `${api.technfe}/v1/emissor/cnpj/${restaurante.data.cnpj}`,
              options,
            );
            setSerieDefault(response2.data.terminais[0].serie);
          } catch (error) {
            console.error('Erro ao carregar emissor:', error);
          } finally {
          }
          console.log(restaurante.data);
        });
    }
  }, [idUser, accessToken]);

  const getDataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const formatarDocumento = documento => {
    const documentoSemMascara = documento.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (documentoSemMascara.length === 11) {
      // Se o documento tem 11 dígitos, é um CPF
      return documentoSemMascara.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        '$1.$2.$3-$4',
      ); // Formato: XXX.XXX.XXX-XX
    } else if (documentoSemMascara.length === 14) {
      // Se o documento tem 14 dígitos, é um CNPJ
      return documentoSemMascara.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5',
      ); // Formato: XX.XXX.XXX/XXXX-XX
    } else {
      // Caso contrário, retorna o documento original
      return documento;
    }
  };

  return (
    <div className="container">
      <header className="modal-header">
        <Button
          type="primary"
          onClick={() => { closeModal(); focarCodigoDeBarras(); }}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Voltar</span>
        </Button>
        <h1>Finalizar Orçamento</h1>
      </header>
      {
        isModalVisibleConsumidor ? (

          <IdentificarConsumidor
            onClose={toggleModalIdentificarConsumidor}
            isVisible={isModalVisibleConsumidor}
            nomeDoCupom={setNomeCupom}
            documentoDoCupom={setDocumentoCupom}
            setConsumidorIdentificado={setConsumidorIdentificado}
            consumidorIdentificado={consumidorIdentificado}
            consumidor={consumidor}
            setConsumidor={setConsumidor}

            documentoIntegracao={documentoCupom}
            emailNota={emailNota}
            setEmailNota={setEmailNota}
            telefoneEnvio={telefoneEnvio}
            setTelefoneEnvio={setTelefoneEnvio}
            telaOrcamento={true}
          ></IdentificarConsumidor>

        ) :
          isModalVisiblePagamento ? (
            <PaymentScreen onClose={toggleModalPagamento}
              isVisible={isModalVisiblePagamento}
              precoTotal={precoTotal.toFixed(2)}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagItem={setPagItem}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              idLoja={config.restaurante.id}
              totalPago={totalPago}
              setTotalPago={setTotalPago}
              formasDePagamento={formasDePagamento}
            ></PaymentScreen>
          ) : isModalVisibleParametros ? (

            <Parametros
              onClose={toggleModalParametros}
              isVisible={isModalVisibleParametros}
              precoTotal={precoTotal}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagItem={setPagItem}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              setIndPag={setIndPag}
              indPag={indPag}
              parametros={parametros}
              setParametros={setParametros}


            >

            </Parametros>


















          ) :


            isModalVisibleAcresDesc ? (<AcrescimoDescontoTotal
              onClose={toggleModalAcresDesc}
              isVisible={isModalVisibleAcresDesc}
              precoTotal={precoTotal}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagItem={setPagItem}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              acresDescFrete={acresDescFrete}
              setAcresDescFrete={setAcresDescFrete}
              produtos={produtos}
              setProdutos={setProdutos}
              CalcularTotais={CalcularTotais}
              subTotal={subTotal}
              setAcrescimoDescontosFreteConcluido={
                setAcrescimoDescontosFreteConcluido
              }></AcrescimoDescontoTotal>) :

              (
                <>
                  <div style={estiloContainerButtons}>
                    {/* Linha 1 */}
                    <div style={estiloButtonsRow}>
                      <button
                        style={{
                          ...estiloBotao,
                          background:
                            consumidorIdentificado || documentoCupom
                              ? 'linear-gradient(135deg, #22c55e, #15803d)'
                              : 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
                        }}
                        onClick={toggleModalIdentificarConsumidor}
                      >
                        <span style={estiloIconeBotao}>👤</span>

                        <span style={estiloConteudoBotao}>
                          <span style={estiloTituloBotao}>
                            Identificar Consumidor
                          </span>

                          <span style={estiloDescricaoBotao}>
                            CPF, CNPJ e dados do cliente
                          </span>
                        </span>
                      </button>

                      <button
                        style={{
                          ...estiloBotao,
                          background: travarAcrescimoDescFrete
                            ? 'linear-gradient(135deg, #b8b8b8, #909090)'
                            : 'linear-gradient(135deg, #f59e0b, #ea580c)',
                          cursor: travarAcrescimoDescFrete
                            ? 'not-allowed'
                            : 'pointer',
                          opacity: travarAcrescimoDescFrete ? 0.65 : 1,
                        }}
                        onClick={() => {
                          if (!travarAcrescimoDescFrete) {
                            toggleModalAcresDesc();
                          }
                        }}
                        disabled={travarAcrescimoDescFrete}
                      >
                        <span style={estiloIconeBotao}>％</span>

                        <span style={estiloConteudoBotao}>
                          <span style={estiloTituloBotao}>
                            Acréscimos e Descontos
                          </span>

                          <span style={estiloDescricaoBotao}>
                            Ajuste os valores da venda
                          </span>
                        </span>
                      </button>
                    </div>

                    {/* Linha 2 */}
                    <div style={estiloButtonsRow}>
                      <button
                        style={{
                          ...estiloBotao,
                          background: possuiPagamento
                            ? 'linear-gradient(135deg,#22C55E,#15803D)'
                            : 'linear-gradient(135deg,#374151,#111827)',
                        }}
                        onClick={toggleModalPagamento}
                      >
                        <span style={estiloIconeBotao}>
                          💳
                        </span>

                        <span style={estiloConteudoBotao}>
                          <span style={estiloTituloBotao}>
                            Pagamento
                          </span>

                          <span style={estiloDescricaoBotao}>
                            {obterResumoPagamentos()}
                          </span>
                        </span>
                      </button>

                      {/*<button
                        style={{
                          ...estiloBotao,
                          background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                        }}
                        onClick={toggleModalParametros}
                      >
                        <span style={estiloIconeBotao}>⚙</span>

                        <span style={estiloConteudoBotao}>
                          <span style={estiloTituloBotao}>
                            Parâmetros
                          </span>

                          <span style={estiloDescricaoBotao}>
                            Configurações da emissão
                          </span>
                        </span>
                      </button>*/}
                    </div>
                    {/* Usuário responsável pela venda */}
                    {(habilitarSelecaoVendedor && tipoTela === "Pedidos") && (
                      <div
                        style={{
                          width: '100%',
                          marginTop: '12px',
                          marginBottom: '12px',
                        }}
                      >
                        <div
                          style={{
                            marginBottom: '6px',
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#374151',
                          }}
                        >
                          👤 Usuário responsável pela venda
                        </div>

                        <Select
                          showSearch
                          allowClear
                          loading={loadingUsuarios}
                          placeholder="Selecione o usuário responsável pela venda"
                          value={usuarioSelecionado}
                          onChange={(value) => setUsuarioSelecionado(value)}
                          optionFilterProp="label"
                          style={{
                            width: '100%',
                          }}
                          options={usuarios.map((usuario) => ({
                            value: usuario.id,
                            label: usuario.nome,
                          }))}
                        />
                      </div>
                    )}
                    {/* Linha 3 */}

                    <div style={estiloButtonsRow}>
                      {tipoTela === "Orçamentos" ? <button
                        style={{
                          ...estiloBotao,
                          background:
                            !pagamentoConcluido ||
                              loading ||
                              (consumidor &&
                                consumidor?.endereco?.ufEstado !==
                                loja?.endereco?.cidade?.estado &&
                                consumidor?.endereco?.ufEstado != null)
                              ? 'linear-gradient(135deg, #b8b8b8, #909090)'
                              : 'linear-gradient(135deg, #22c55e, #15803d)',

                          cursor:
                            !pagamentoConcluido ||
                              loading ||
                              (consumidor &&
                                consumidor?.endereco?.ufEstado !==
                                loja?.endereco?.cidade?.estado &&
                                consumidor?.endereco?.ufEstado != null)
                              ? 'not-allowed'
                              : 'pointer',

                          opacity:
                            !pagamentoConcluido ||
                              loading ||
                              (consumidor &&
                                consumidor?.endereco?.ufEstado !==
                                loja?.endereco?.cidade?.estado &&
                                consumidor?.endereco?.ufEstado != null)
                              ? 0.65
                              : 1,
                        }}
                        onClick={imprimirOrcamento}
                        disabled={!pagamentoConcluido || loading || !config.restaurante}
                      >
                        <span style={estiloIconeBotao}>🧾</span>

                        <span style={estiloConteudoBotao}>
                          <span style={estiloTituloBotao}>
                            Imprimir Orçamento
                          </span>

                          <span style={estiloDescricaoBotao}>
                            Finalizar com Orçamento
                          </span>
                        </span>
                      </button> : <button
                        style={{
                          ...estiloBotao,
                          background:
                            !pagamentoConcluido ||
                              loading ||
                              (consumidor &&
                                consumidor?.endereco?.ufEstado !==
                                loja?.endereco?.cidade?.estado &&
                                consumidor?.endereco?.ufEstado != null)
                              ? 'linear-gradient(135deg, #b8b8b8, #909090)'
                              : 'linear-gradient(135deg, #22c55e, #15803d)',

                          cursor:
                            !pagamentoConcluido ||
                              loading ||
                              (consumidor &&
                                consumidor?.endereco?.ufEstado !==
                                loja?.endereco?.cidade?.estado &&
                                consumidor?.endereco?.ufEstado != null)
                              ? 'not-allowed'
                              : 'pointer',

                          opacity:
                            !pagamentoConcluido ||
                              loading ||
                              (consumidor &&
                                consumidor?.endereco?.ufEstado !==
                                loja?.endereco?.cidade?.estado &&
                                consumidor?.endereco?.ufEstado != null)
                              ? 0.65
                              : 1,
                        }}
                        onClick={imprimirPedido}
                        disabled={!pagamentoConcluido || loading || !config.restaurante}
                      >
                        <span style={estiloIconeBotao}>📄</span>

                        <span style={estiloConteudoBotao}>
                          <span style={estiloTituloBotao}>
                            Imprimir Pedido
                          </span>

                          <span style={estiloDescricaoBotao}>
                            Finalizar com Pedido
                          </span>
                        </span>
                      </button>}



                    </div>
                  </div>
                  {/*  <div className="container-buttons">

                    <div className="row">
                      <button
                        className={`button ${consumidorIdentificado ? 'button-success' : 'button-purple'}`}
                        onClick={toggleModalIdentificarConsumidor}
                      >
                        Identificar Consumidor
                      </button>
                    </div>


                    <div className="row">
                      <button className="button button-warning" onClick={toggleModalAcresDesc}>
                        Acréscimos e Descontos
                      </button>
                    </div>

                    <div className="row">
                      <button className="button button-dark" onClick={toggleModalPagamento}>
                        Pagamento
                      </button>
                    </div>
                    <div className="row">
                      <button className={`button button-disabled`} onClick={toggleModalParametros} disabled>
                        Parâmetros
                      </button>
                    </div>
                    <div className="row">
                      <button
                        className={`button ${pagamentoConcluido && !loading ? 'button-success' : 'button-disabled'}`}
                        onClick={imprimirOrcamento}
                        disabled={!pagamentoConcluido || loading || !config.restaurante}
                      >
                        {loading ? 'Processando...' : 'Imprimir Orçamento'}
                      </button>
                    </div>

                    <div className="row">
                      <button
                        className={`button ${pagamentoConcluido && !loading ? 'button-success' : 'button-disabled'}`}
                        onClick={imprimirPedido}
                        disabled={!pagamentoConcluido || loading || !config.restaurante}
                      >
                        {loading ? 'Processando...' : 'Imprimir Pedido'}
                      </button>
                    </div>
                  </div>
*/}

                  <div style={estiloGridResumoVenda}>
                    {/* Área esquerda */}
                    <div style={estiloAreaResumoVenda}>
                      {/* Data, e-mail e telefone */}
                      <div style={estiloGridCabecalho}>
                        <div style={estiloCardPequeno}>
                          <span style={estiloLabelResumo}>Data</span>
                          <strong style={estiloValorResumo}>
                            {getDataAtual()}
                          </strong>
                        </div>

                        <div style={estiloCardPequeno}>
                          <span style={estiloLabelResumo}>E-mail de envio</span>
                          <strong style={estiloValorResumo}>
                            {consumidor?.email || emailNota || 'Não informado'}
                          </strong>
                        </div>

                        <div style={estiloCardPequeno}>
                          <span style={estiloLabelResumo}>Telefone de envio</span>
                          <strong style={estiloValorResumo}>
                            {telefoneEnvio
                              ? formatarTelefone(telefoneEnvio)
                              : 'Não informado'}
                          </strong>
                        </div>
                      </div>

                      {/* Totais gerais da venda */}
                      <div style={estiloGridTotaisVenda}>
                        <div style={estiloCardPequeno}>
                          <span style={estiloLabelResumo}>Subtotal da venda</span>
                          <strong style={estiloValorResumo}>
                            {formatarMoeda(subTotal)}
                          </strong>
                        </div>

                        <div style={estiloCardPequeno}>
                          <span style={estiloLabelResumo}>Desconto da venda</span>
                          <strong style={estiloValorResumo}>
                            {formatarMoeda(totalDescontos)}
                          </strong>
                        </div>

                        <div style={estiloCardPequeno}>
                          <span style={estiloLabelResumo}>Total da venda</span>
                          <strong
                            style={{
                              ...estiloValorResumo,
                              color: '#16a34a',
                              fontSize: '19px',
                            }}
                          >
                            {formatarMoeda(precoTotal)}
                          </strong>
                        </div>
                      </div>

                      {/* Produtos */}
                      <CardNotaFiscal
                        icone="📦"
                        titulo="Nota Fiscal de Produtos"
                        subtotal={subTotalProdutos}
                        descontos={totalDescontosProdutos}
                        acrescimos={totalAcrescimosProdutos}
                        frete={freteProdutos}
                        total={totalProdutos}
                      />

                      {/* Serviços */}
                      <CardNotaFiscal
                        icone="🛠️"
                        titulo="Nota Fiscal de Serviços"
                        subtotal={subTotalServicos}
                        descontos={totalDescontosServicos}
                        acrescimos={totalAcrescimosServicos}
                        total={totalServicos}
                        mostrarFrete={false}
                      />

                      {parametros?.infCpl && (
                        <div style={estiloCardFinanceiro}>
                          <div style={estiloTituloCardFinanceiro}>
                            <span>📝</span>
                            <span>Observação da DANFE</span>
                          </div>

                          <p style={estiloObservacao}>
                            {parametros.infCpl}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Área direita */}
                    <div style={estiloCardConsumidor}>
                      <div style={estiloTituloConsumidor}>
                        <span>👤</span>
                        <span>Dados do Cliente</span>
                      </div>

                      <div style={estiloLinhaConsumidor}>
                        <span style={estiloLabelResumo}>Nome</span>
                        <span style={estiloValorConsumidor}>
                          {consumidor?.nome ||
                            consumidor?.razaoSocial || consumidor?.nomeCompleto ||
                            'Não informado'}
                        </span>
                      </div>

                      <div style={estiloLinhaConsumidor}>
                        <span style={estiloLabelResumo}>CPF/CNPJ</span>
                        <span style={estiloValorConsumidor}>
                          {documentoCupom
                            ? formatarDocumento(documentoCupom)
                            : consumidor?.documentoCpfCnpj
                              ? formatarDocumento(consumidor.documentoCpfCnpj)
                              : 'Não informado'}
                        </span>
                      </div>

                      {(consumidor?.ie || consumidor?.documentoRgIE) && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>IE/RG</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor?.ie || consumidor?.documentoRgIE}
                          </span>
                        </div>
                      )}

                      {consumidor?.endereco?.logradouro && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>Logradouro</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor.endereco.logradouro}
                          </span>
                        </div>
                      )}

                      {consumidor?.endereco?.numero && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>Número</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor.endereco.numero}
                          </span>
                        </div>
                      )}

                      {consumidor?.endereco?.bairro && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>Bairro</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor.endereco.bairro}
                          </span>
                        </div>
                      )}

                      {consumidor?.endereco?.cidade?.nome && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>Cidade</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor.endereco.cidade.nome}   {consumidor?.endereco?.cidade?.ibge}
                          </span>
                        </div>
                      )}

                      {(consumidor?.endereco?.ufEstado ||
                        consumidor?.endereco?.cidade?.estado) && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>Estado</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor?.endereco?.ufEstado ||
                                consumidor?.endereco?.cidade?.estado}
                            </span>
                          </div>
                        )}

                      {consumidor?.endereco?.cep && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>CEP</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor.endereco.cep}
                          </span>
                        </div>
                      )}

                      {consumidor?.telefone && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>Telefone</span>
                          <span style={estiloValorConsumidor}>
                            {formatarTelefone(consumidor.telefone)}
                          </span>
                        </div>
                      )}

                      {consumidor?.email && (
                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>E-mail</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor.email}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>












                </>
              )
      }

    </div>
  );
};


const estiloContainerButtons = {
  width: '100%',
  maxWidth: '680px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  marginTop: 10
};

const estiloButtonsRow = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '14px',
};

const estiloBotao = {
  width: '100%',
  minHeight: '96px',
  padding: '16px 18px',
  border: '1px solid rgba(255, 255, 255, 0.15)',
  borderRadius: '14px',
  color: '#fff',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '14px',

  textAlign: 'left',
  boxSizing: 'border-box',
  cursor: 'pointer',

  boxShadow:
    '0 7px 18px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.12)',

  transition:
    'transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease',
};

const estiloIconeBotao = {
  width: '50px',
  height: '50px',
  minWidth: '50px',
  borderRadius: '13px',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  backgroundColor: 'rgba(255, 255, 255, 0.17)',
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.2)',

  fontSize: '25px',
  lineHeight: '1',
};

const estiloConteudoBotao = {
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
};

const estiloTituloBotao = {
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '1.2',
};

const estiloDescricaoBotao = {
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '1.3',
  opacity: 0.82,
};

const estiloP = {
  margin: "5px 0",
  fontWeight: "bold",
  fontSize: "14px",
  width: "100%",
  whiteSpace: "pre-wrap",    // mantém quebras e força quebra automática
  wordBreak: "break-word",   // força quebra em palavras longas
  overflowWrap: "break-word" // extra segurança
};
const estiloObservacao = {
  ...estiloP,
  maxHeight: "150px",  // limita a altura visível
  overflowY: "auto",   // adiciona scroll vertical se passar disso
};

const estiloGridResumoVenda = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 3fr) minmax(260px, 1fr)',
  gap: '12px',
  width: '100%',
  boxSizing: 'border-box',
  marginTop: 10
};

const estiloAreaResumoVenda = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minWidth: 0,
};

const estiloGridCabecalho = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '12px',
};

const estiloGridTotaisVenda = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '12px',
};

const estiloCardPequeno = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '68px',
  padding: '10px 14px',
  backgroundColor: '#ffffff',
  border: '1px solid #e8e8e8',
  borderRadius: '12px',
  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.04)',
  boxSizing: 'border-box',
  minWidth: 0,
};

const estiloCardFinanceiro = {
  padding: '14px',
  backgroundColor: '#ffffff',
  border: '1px solid #e8e8e8',
  borderRadius: '12px',
  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.04)',
  boxSizing: 'border-box',
};

const estiloTituloCardFinanceiro = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '14px',
  color: '#222222',
  fontSize: '15px',
  fontWeight: '700',
};

const estiloGridFinanceiro = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: '10px',
};

const estiloItemFinanceiro = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
};

const estiloLabelResumo = {
  color: '#777777',
  fontSize: '12px',
  fontWeight: '600',
};

const estiloValorResumo = {
  color: '#222222',
  fontSize: '15px',
  fontWeight: '700',
  wordBreak: 'break-word',
};

const estiloTotalFinanceiro = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  marginTop: '14px',
  paddingTop: '12px',
  borderTop: '2px solid #eeeeee',
};

const estiloLabelTotalFinanceiro = {
  color: '#222222',
  fontSize: '15px',
  fontWeight: '700',
};

const estiloValorTotalFinanceiro = {
  color: '#16a34a',
  fontSize: '20px',
  fontWeight: '800',
};

const estiloCardConsumidor = {
  padding: '16px',
  backgroundColor: '#ffffff',
  border: '1px solid #e8e8e8',
  borderRadius: '12px',
  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.04)',
  boxSizing: 'border-box',
  minWidth: 0,
};

const estiloTituloConsumidor = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '14px',
  color: '#222222',
  fontSize: '16px',
  fontWeight: '700',
};

const estiloLinhaConsumidor = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  padding: '7px 0',
  borderBottom: '1px solid #f0f0f0',
};

const estiloValorConsumidor = {
  color: '#222222',
  fontSize: '13px',
  fontWeight: '600',
  wordBreak: 'break-word',
};


export default FinalizarOrcamento;